







































	import {
		Instance, Product
	} from '@/classes/TayehApi';
import { SetInstanceProductPriceFilterRequest } from '@/classes/TayehApi/Instance';
	import { Component, Prop, Vue } from 'vue-property-decorator';

	@Component
	export default class CreateProductPricingForm extends Vue {
		@Prop() productId: string;
		@Prop() instanceId: number;
		loading =  false;
		pricableFilters: any[] = null;
		filter: any = {
			id: null
		};
		prices: any[] = [];
		async save() {
			this.loading = true;
			const params: SetInstanceProductPriceFilterRequest = {
				filter_id: this.filter.id,
				prices: this.prices.map(p => ({
					name: p.option.value,
					id: p.id,
					price: p.price,
					price_with_off: p.price_with_off,
					limit: 0,
					option_id: p.option.id
				}))
			}
			try {
				await Instance.setProductPriceFilter(this.instanceId, this.productId, params);
				this.$message({
						showClose: true,
						message: 'تنظیم دسته بندی انجام شد. در حال ذخیره قیمت ها ...',
						type: 'success',
						duration: 5000
					});
					this.$emit('updated');
			} catch (err) {
				console.log(err);
				this.$message({
						showClose: true,
						message: 'لطفا از صحیح بودن قیمت های وارد شده مطمئن شوید.',
						type: 'error',
						duration: 5000
				});
			} finally {
				this.getProductPriceFilter();
				this.loading = false;
			}
		}

		async getProductPriceFilter() {
			this.loading = true;
			try {
				const res = await Instance.getInstanceProductPriceForm(this.instanceId,this.productId);
				console.log('get product price',res.data);
				this.filter = res.data.filter||{id: null};
				this.pricableFilters = res.data.product_price_filters;
				this.prices = res.data.prices;
				
			} catch (err) {
				console.log(err);
			}
			this.loading = false;
		}
		
		async getFilterPrices(id: string) {
			this.loading = true;
			try {
				const res = await Instance.getInstanceProductFilterPriceForm(this.instanceId, this.productId, id);
				this.prices = res.data.prices;
			} catch (err) {
				console.log(err);
			}
			this.loading = false;
		}
		mounted() {
			this.getProductPriceFilter()
		}
	}
